module.exports = __webpack_public_path__ + "img/caas4m-m@2.09152c19.jpg";